import { useRecordsFieldOptionsConfig } from "../../../../../RecordsFieldOptionsConfig/context.js";
import { toOptionsWithExisting } from "../../../../../RecordsFieldOptionsConfig/utils.js";
/* empty css                 */
import { EditableRecordField } from "../../../EditableRecordField/index.js";
import "react";
import { Constants, Label, useContainerDimensionsContext } from "@therms/atalaya";
import { jsx, jsxs } from "react/jsx-runtime";
import classnames from "classnames";
//#region src/modules/Records/shared/RecordModal/components/InfoTab/VehicleRecordFields.tsx
function VehicleRecordFields({ canEdit, onFieldChange, record }) {
	const { viewport: { width: mainWidth } } = useContainerDimensionsContext();
	const config = useRecordsFieldOptionsConfig();
	let layout = "Xxl";
	if (mainWidth < Constants.Breakpoint.Sm.width) layout = "Sm";
	else if (mainWidth < Constants.Breakpoint.Xl.width) layout = "Xl";
	return /* @__PURE__ */ jsxs("div", {
		className: "grid grid-cols-6",
		children: [
			/* @__PURE__ */ jsxs("div", {
				className: classnames({ "col-span-6": layout === "Sm" }),
				children: [/* @__PURE__ */ jsx(Label, {
					block: true,
					className: "label",
					children: "Year"
				}), /* @__PURE__ */ jsx(EditableRecordField, {
					canEdit,
					fieldName: "year",
					fieldType: "number",
					onComplete: onFieldChange,
					value: record.fields.year
				})]
			}),
			/* @__PURE__ */ jsxs("div", {
				className: classnames({
					"col-span-2": layout === "Xxl" || layout === "Xl",
					"col-span-6": layout === "Sm"
				}),
				children: [/* @__PURE__ */ jsx(Label, {
					block: true,
					className: "label",
					children: "Color"
				}), /* @__PURE__ */ jsx(EditableRecordField, {
					canEdit,
					fieldName: "color",
					fieldType: "select",
					options: toOptionsWithExisting(config?.vehicle.color, record.fields.color),
					onComplete: onFieldChange,
					value: record.fields.color
				})]
			}),
			/* @__PURE__ */ jsxs("div", {
				className: classnames({
					"col-span-3": layout === "Xl" || layout === "Xxl",
					"col-span-6": layout === "Sm"
				}),
				children: [/* @__PURE__ */ jsx(Label, {
					block: true,
					className: "label",
					children: "Type"
				}), /* @__PURE__ */ jsx(EditableRecordField, {
					canEdit,
					fieldName: "type",
					fieldType: "select",
					options: toOptionsWithExisting(config?.vehicle.type, record.fields.type),
					onComplete: onFieldChange,
					value: record.fields.type
				})]
			}),
			/* @__PURE__ */ jsxs("div", {
				className: classnames({
					"col-span-3": layout === "Xxl" || layout === "Xl",
					"col-span-6": layout === "Sm"
				}),
				children: [/* @__PURE__ */ jsx(Label, {
					block: true,
					className: "label",
					children: "Make"
				}), /* @__PURE__ */ jsx(EditableRecordField, {
					canEdit,
					fieldName: "make",
					fieldType: "text",
					onComplete: onFieldChange,
					value: record.fields.make
				})]
			}),
			/* @__PURE__ */ jsxs("div", {
				className: classnames({
					"col-span-3": layout === "Xxl" || layout === "Xl",
					"col-span-6": layout === "Sm"
				}),
				children: [/* @__PURE__ */ jsx(Label, {
					block: true,
					className: "label",
					children: "Model"
				}), /* @__PURE__ */ jsx(EditableRecordField, {
					canEdit,
					fieldName: "model",
					fieldType: "text",
					onComplete: onFieldChange,
					value: record.fields.model
				})]
			}),
			/* @__PURE__ */ jsxs("div", {
				className: classnames({
					"col-span-2": layout === "Xxl",
					"col-span-6": layout === "Sm"
				}),
				children: [/* @__PURE__ */ jsx(Label, {
					block: true,
					className: "label",
					children: "Plate"
				}), /* @__PURE__ */ jsx(EditableRecordField, {
					canEdit,
					fieldName: "plate",
					fieldType: "text",
					onComplete: onFieldChange,
					value: record.fields.plate
				})]
			}),
			/* @__PURE__ */ jsxs("div", {
				className: classnames({
					"col-span-2": layout === "Xxl" || layout === "Xl",
					"col-span-6": layout === "Sm"
				}),
				children: [/* @__PURE__ */ jsx(Label, {
					block: true,
					className: "label",
					children: "State"
				}), /* @__PURE__ */ jsx(EditableRecordField, {
					canEdit,
					fieldName: "state",
					fieldType: "text",
					onComplete: onFieldChange,
					value: record.fields.state
				})]
			}),
			/* @__PURE__ */ jsxs("div", {
				className: classnames({
					"col-span-2": layout === "Xxl",
					"col-span-3": layout === "Xl",
					"col-span-6": layout === "Sm"
				}),
				children: [/* @__PURE__ */ jsx(Label, {
					block: true,
					className: "label",
					children: "Vin"
				}), /* @__PURE__ */ jsx(EditableRecordField, {
					canEdit,
					fieldName: "vin",
					fieldType: "text",
					onComplete: onFieldChange,
					value: record.fields.vin
				})]
			}),
			/* @__PURE__ */ jsxs("div", {
				className: "col-span-6",
				children: [/* @__PURE__ */ jsx(Label, {
					block: true,
					className: "label",
					children: "Additional Info"
				}), /* @__PURE__ */ jsx(EditableRecordField, {
					canEdit,
					fieldName: "additional",
					fieldType: "textarea",
					onComplete: onFieldChange,
					value: record.fields.additional
				})]
			})
		]
	});
}
//#endregion
export { VehicleRecordFields };

//# sourceMappingURL=VehicleRecordFields.js.map